<template>
  <div class="app">
    <scroll :class="{ 'to-bottom-btn': toBottomBtn }" @refresh="refresh">
      <div>
        <section>
          <div class="text-center row thick bg-gray">
            <span class="f-minor">订单状态：</span>
            <span
              class="f-strong"
              v-if="
                regDetail.regStatus === 4 &&
                (regDetail.orderStatus === 1 || regDetail.orderStatus === 2)
              "
              >已预约</span
            >
            <span class="f-strong" v-else-if="regDetail.regStatus === 5"
              >已取消</span
            >
            <span class="f-strong" v-else-if="regDetail.orderStatus === 3"
              >已支付</span
            >
            <span class="f-strong" v-else-if="regDetail.orderStatus === 4"
              >已支付</span
            >
            <span class="f-strong" v-else-if="regDetail.orderStatus === 5"
              >已退号</span
            >
          </div>
          <dl class="field">
            <dt>医院</dt>
            <dd>{{ regDetail.hospitalName }}</dd>
          </dl>
          <dl class="field">
            <dt>院区科室</dt>
            <dd>{{ regDetail.areaName }}/{{ regDetail.deptName }}</dd>
          </dl>
          <dl class="field">
            <dt>科室地址</dt>
            <dd>{{ regDetail.deptAddress }}</dd>
          </dl>
          <dl class="field">
            <dt>医生</dt>
            <dd>
              <span class="mydoctor">{{ regDetail.doctName }}</span>
            </dd>
          </dl>
          <dl class="field last">
            <dt>门诊类型</dt>
            <dd>{{ regDetail.typeName }}门诊</dd>
          </dl>
        </section>
        <section>
          <dl class="field">
            <dt>就诊人</dt>
            <dd>{{ regDetail.holderName }}/{{ mobileNo }}</dd>
          </dl>
          <dl class="field">
            <dt>就诊时间</dt>
            <dd>{{ regDetail.visitTime | formatDate }}</dd>
          </dl>
          <dl class="field">
            <dt>就诊序号</dt>
            <dd>{{ regDetail.visitNo }}</dd>
          </dl>
          <dl class="field last">
            <dt>挂号时间</dt>
            <dd>{{ regDetail.orderTime | formatDate }}</dd>
          </dl>
        </section>
        <section>
          <dl class="field">
            <dt>订单号</dt>
            <dd>{{ regDetail.orderId }}</dd>
          </dl>
          <dl class="field last">
            <dt>挂号金额</dt>
            <dd class="f-strongest">{{ regDetail.fee | formatFee }}</dd>
          </dl>
        </section>
      </div>
      <section class="tips mytips" v-if="regDetail.areaType === '1'">
        <span class="f-strong">提示信息：</span>
        <br />
        1、请您在预约时间前30分钟到达医院对应科室候诊。 <br />
        2、如您不能按时就诊，请提前一天（晚上凌晨以前）取消预约，系统会自动退还预约费用。
        <br />
        3、如果当天需要取消预约，请在门诊收费窗口办理。
      </section>
      <section class="tips mytips" v-if="regDetail.areaType === '2'">
        <span class="f-strong">提示信息：</span>
        <br />请您携带居民健康卡在预约时间前30分钟到达医院支付挂号费取号。
      </section>
    </scroll>
    <footer>
      <div
        v-if="regDetail.orderStatus === 2 && regDetail.regStatus === 4"
        class="flex-row flex-align-center"
      >
        <div class="flex-1 flex-width" style="padding: 0 0.5rem">
          <span class="myfee">总金额</span>
          <span class="f-strongest">{{ regDetail.fee | formatFee }}</span>
        </div>
        <button @click.stop="goPay()" class="btn-bottom-right">立即缴费</button>
      </div>
      <button
        v-if="isPaySuccess"
        class="btn-complete"
        type="button"
        @click="finished()"
      >
        完成
      </button>
    </footer>
    <payConfirm v-model="showPayConfirm"></payConfirm>
  </div>
</template>
<script>
import myRegisterService from 'myRegister.service'
import PayConfirm from 'PayConfirm'
export default {
  components: {
    PayConfirm
  },
  data () {
    return {
      regDetailParams: {},
      regDetail: {
        areaType: localStorage.selectedHospital.areaType,
        orderId: "",
        orderTime: "",
        deptName: "",
        deptAddress: "",
        doctName: "",
        rankName: "",
        orderStatus: 0,
        regStatus: 0,
        fee: 0,
        visitNo: "",
        visitTime: "",
        areaId: "",
        areaName: "",
        hospitalId: "",
        hospitalName: "",
        cardType: "",
        cardNo: "",
        holderName: "",
        typeId: "",
        typeName: ""
      },
      message: "",
      isPaySuccess: false,
      mobileNo: localStorage.mobileNo,
      showPayConfirm: false
    }
  },
  computed: {
    toBottomBtn () {
      return (this.regDetail.orderStatus === 2) || this.isPaySuccess;
    }
  },
  mounted () {
    this.refresh();
  },
  methods: {
    refresh: function () {
      var query = this.$router.currentRoute.query;
      if (query.orderId) {
        this.regDetailParams.cardType = query.cardType;
        this.regDetailParams.cardNo = query.cardNo;
        this.regDetailParams.orderType = 1;
        this.regDetailParams.orderId = query.orderId;
        this.isPaySuccess = false;
        var hospital = {};
        hospital.hospitalId = query.hospitalId;
        hospital.hospitalIndex = query.hospitalIndex;
        hospital.hospitalName = query.hospitalName;
        hospital.hospitalType = query.hospitalType;
        localStorage.selectedHospital = JSON.stringify(hospital);
        http.headers.common['hospitalId'] = hospital.hospitalId;
      } else {
        this.regDetailParams = this.$store.state.paramModule.param.regDetail.registerInfo;
        this.isPaySuccess = this.$store.state.paramModule.param.regDetail.isPaySuccess;
      }
      this.loadRegDetail(this.regDetailParams);
    },
    loadRegDetail: function (params) {
      myRegisterService.loadRegDetail(params).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        this.regDetail = res.data;
        var orderStatus = (this.regDetail.orderStatus).toString();
        switch (orderStatus) {
          case this.constant.ORDER_STATUS.UNABLE_PAYMENT:
            //未支付（不可支付）
            this.isPaySuccess = true;
            this.message = '';
            break;
          case this.constant.ORDER_STATUS.ABLE_PAYMENT:
            //未支付（可支付）
            this.message = '去支付';
            break;
          case this.constant.ORDER_STATUS.UNABLE_RETURN_FEE:
            //已支付(不可退费)
            this.message = '已支付';
            break;
          case this.constant.ORDER_STATUS.ABLE_RETURN_FEE:
            //已支付(可退费)
            this.message = '已支付';
            break;
          default:
            break;
        }
      });
    },
    goPay: function () {
      this.$store.commit('updateParam', {
        namespace: 'pay',
        // 支付模块所需要的参数
        payInfo: {
          cardType: this.regDetail.cardType,
          cardNo: this.regDetail.cardNo,
          orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE, // 1挂号2门诊
          fee: this.regDetail.fee,
          orderId: this.regDetail.orderId,
          busiType: this.constant.BUSI_TYPE.REGISTRATION_PAYMENT
        }
      });
      //判断是否0元需求
      if (parseFloat(this.regDetail.fee) <= 0) {
        this.zeroPay(this.regDetail);
        return;
      }
      this.showPayConfirm = true;
    },
    //0元需求
    zeroPay (response) {
      // 从上级获取参数
      const params = {
        orderId: response.orderId,
        orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,
        cardType: response.cardType,
        cardNo: response.cardNo,
        channelId: '4',
        // app 1; h5 2; o2o 3;
        invokeType: this.constant.INVOKE_TYPE.WAP_INVOKE,
        busiType: this.constant.BUSI_TYPE.REGISTRATION_PAYMENT,
        fee: response.fee,
        deviceId: this.code,
      }
      // 生成外部订单号
      this.loadOutOrder(params)
    },
    loadOutOrder (params) {
      this.$http.post('/app/pay/order', params).then((res) => {
        if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
          // 跳转支付成功或失败界面
          this.$store.commit('updateParam', {
            namespace: 'paySuccess',
            paySuccessInfo: {
              orderId: params.orderId,
              fee: params.fee,
              busiType: params.busiType,
            },
          })
          this.$router.replace('paySuccess')
        } else {
          this.$utils.alert(res.data.resultMsg)
        }
      })
    },
    finished: function () {
      this.$router.replace('/');
    }
  }
}
</script>
<style lang="scss">
.mydoctor {
  margin-right: 0.25rem;
}

.mytips {
  font-size: 0.625rem;
  background: white;
  color: gray;
}

.myfee {
  margin-right: 0.25rem;
}

.goPay {
  height: 2.75rem;
  background-color: #fff;
  width: 100%;
  font-size: 0.9rem;
  line-height: 2.75rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// RegDetail.vue?00663e3f